<div class="loadable" [class.loading]="loadingLevel === 'ALL'">
    <ui-banner *ngIf="error === 'LOADING_ERROR'" variant="danger">
        {{ 'settings.signIn.mfa.loadingFailedErrorMessage' | translate }}
    </ui-banner>
    <div class="setting" [class.disabled]="error === 'LOADING_ERROR'">
        <div class="setting-description">
            <h3>
                {{ 'settings.signIn.mfa.title' | translate }}
            </h3>
            <div>{{ 'settings.signIn.mfa.description' | translate }}</div>
        </div>
        <mat-slide-toggle
            color="primary"
            [disabled]="error === 'LOADING_ERROR'"
            (change)="isMFAEnabled = !isMFAEnabled"
            [checked]="isMFAEnabled"
        >
        </mat-slide-toggle>
    </div>
    @if (isMFAEnabled !== false) {
        <app-checkbox-hierarchy label="roles" (change)="onRoleToggle('ALL')">
            <app-checkbox-hierarchy
                label="settings.roles.defaultRolesTableTitle"
                [isLoading]="loadingLevel === 'DEFAULT'"
                (change)="onRoleToggle('DEFAULT')"
            >
                <app-checkbox-hierarchy
                    *ngFor="let role of activeMFARoles.DEFAULT | keyvalue"
                    [label]="roleNameDisplayOptions[role.value.name] ?? role.value.name"
                    [(ngModel)]="role.value.isMFAEnabled"
                    (change)="onRoleToggle(role.value.id)"
                    [isLoading]="loadingLevel === role.value.id"
                />
            </app-checkbox-hierarchy>
            <app-checkbox-hierarchy
                label="settings.roles.customRolesTableTitle"
                [isLoading]="loadingLevel === 'CUSTOM'"
                (change)="onRoleToggle('CUSTOM')"
            >
                <app-checkbox-hierarchy
                    *ngFor="let role of activeMFARoles.CUSTOM | keyvalue"
                    [label]="role.value.name"
                    [(ngModel)]="role.value.isMFAEnabled"
                    (change)="onRoleToggle(role.value.id)"
                    [isLoading]="loadingLevel === role.value.id"
                />
            </app-checkbox-hierarchy>
        </app-checkbox-hierarchy>
    }
</div>
